import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Platform } from 'react-native';

import { CustomNavigationHeader, getIosModalPresentationConfig, useResponsive } from '@sg/garnish';

import { Modal } from '../Modal';
import { DebugMenu } from './DebugMenu';

// ─────────────────────────────────────────────────────────────────────────────

export const DebugMenuModal = (props: DebugMenuModalProps) => {
  const { visible, onRequestClose } = props;

  const { formatMessage } = useIntl();
  const { match, currentBreakpoint } = useResponsive();

  const sheetPresentationConfig = currentBreakpoint.isXS ? getIosModalPresentationConfig() : undefined; // prettier-ignore

  return (
    <Modal
      visible={visible}
      accessibilityLabel={formatMessage(messages.title)}
      fitHeight={currentBreakpoint.isXS}
      size={match(['full', 'large'])}
      onRequestClose={onRequestClose}
      {...sheetPresentationConfig}
    >
      <CustomNavigationHeader.Container safeAreaEdges={HEADER_SAFE_AREA_EDGES} transition={null}>
        <CustomNavigationHeader.Text textAlignment="center" numberOfLines={1}>
          <FormattedMessage {...messages.title} />
        </CustomNavigationHeader.Text>

        <CustomNavigationHeader.Button.Right
          name="IconClose"
          accessibilityLabel={formatMessage(messages.closeButtonA11yLabel)}
          onPress={onRequestClose}
        />
      </CustomNavigationHeader.Container>

      <DebugMenu />
    </Modal>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  accessibilityLabel: {
    defaultMessage: 'Open debug menu',
    description: 'Opens the debug menu',
  },
  title: {
    defaultMessage: 'Debug menu',
    description: 'Debug menu title',
  },
  closeButtonA11yLabel: {
    defaultMessage: 'Close debug menu',
    description: 'Debug menu | Close button | A11y label',
  },
});

// ─── Constants ───────────────────────────────────────────────────────────────

const HEADER_SAFE_AREA_EDGES = Platform.select({
  android: ['top'] as const,
  default: [] as const,
});

// ─── Types ───────────────────────────────────────────────────────────────────

type DebugMenuModalProps = {
  visible: boolean;
  onRequestClose: () => void;
};
